<app-navbar-style-one></app-navbar-style-one>
<app-navbar-style-two></app-navbar-style-two>

    <div class="terms-condition-container container">

        <header class="terms-header">
            <h1 i18n>Terms and Conditions</h1>
            <p i18n>Effective Date: 20/02/2025 | Last Updated: 18/02/2025</p>
          </header>
          <section class="terms-content">
        <p i18n>Welcome to Vanuston Intelligence and its product websites, including vanuston.com, medeil.com, medeilplus.com, and other associated platforms (collectively referred to as "Websites"). By accessing or using our Websites, products, or services, you agree to comply with and be bound by these Terms and Conditions.</p>
        <div class="section-title gradient-text">
          <h2 i18n>1. Definitions</h2>
        </div>
        <ul>
            <li i18n><strong>Company:</strong> Vanuston Intelligence, its affiliates, and subsidiaries.</li>
            <li i18n><strong>Websites:</strong> vanuston.com, medeil.com, medeilplus.com, and other product-related platforms.</li>
            <li i18n><strong>User:</strong> Any individual or entity accessing or using the Websites, products, or services.</li>
            <li i18n><strong>Services:</strong> Software, SaaS products, and other offerings provided by Vanuston Intelligence.</li>
        </ul>
        <div class="section-title gradient-text">
             <h2 i18n>2. Acceptance of Terms</h2>
        </div>
        <p i18n>By accessing or using our Websites or Services, you confirm that you:</p>
        <ul>
            <li i18n>Are at least 18 years old or have the legal capacity to enter into a binding agreement.</li>
            <li i18n>Agree to comply with these Terms and Conditions, our Privacy Policy, and any additional terms specific to certain products or services.</li>
        </ul>
        <div class="section-title gradient-text">
             <h2 i18n>3. Use of Services</h2>
        </div>
        <h3 i18n>3.1 Permitted Use</h3>
        <ul>
            <li i18n>You may use our Websites and Services for lawful purposes only.</li>
            <li >You agree not to:
                <ul>
                    <li i18n>Use the Websites or Services for any fraudulent, illegal, or unauthorized purpose.</li>
                    <li i18n>Interfere with or disrupt the functionality of the Websites or Services.</li>
                    <li i18n>Attempt to gain unauthorized access to any part of the Websites, Services, or related systems.</li>
                </ul>
            </li>
        </ul>

        <h3 i18n>3.2 User Account</h3>
        <ul>
            <li i18n>Certain features of our Services may require you to create an account.</li>
            <li i18n>You are responsible for maintaining the confidentiality of your account credentials.</li>
            <li i18n>You agree to notify us immediately of any unauthorized use of your account.</li>
        </ul>
        <div class="section-title gradient-text">
            <h2 i18n>4. Intellectual Property</h2>
        </div>
        <p i18n>All content on the Websites, including text, graphics, logos, images, software, and trademarks, is the property of Vanuston Intelligence and is protected by intellectual property laws.</p>
        <div class="section-title gradient-text">
             <h2 i18n>5. Payment and Subscription</h2>
        </div>
        <p i18n>Pricing for our SaaS products is displayed on the respective product websites and is subject to change without notice.</p>
        <div class="section-title gradient-text">
            <h2 i18n>6. Data Privacy</h2>
        </div>
        <p i18n>Your use of our Websites and Services is governed by our Privacy Policy.</p>
        <div class="section-title gradient-text">
             <h2 i18n>7. Third-Party Links</h2>
        </div>
        <p i18n>Our Websites may contain links to third-party websites or services. We do not endorse or assume responsibility for third-party websites.</p>
        <div class="section-title gradient-text">
              <h2 i18n>8. Limitation of Liability</h2>
        </div>
        <p i18n>Vanuston Intelligence shall not be liable for any indirect, incidental, special, or consequential damages.</p>
        <div class="section-title gradient-text">
              <h2 i18n>9. Indemnification</h2>
        </div>
        <p i18n>You agree to indemnify and hold harmless Vanuston Intelligence, its affiliates, and employees from any claims related to your use of the Websites or Services.</p>
        <div class="section-title gradient-text">
             <h2 i18n>10. Termination</h2>
        </div>
        <p i18n>We reserve the right to suspend or terminate your access to the Websites or Services at our discretion.</p>
        <div class="section-title gradient-text">
           <h2 i18n>11. Governing Law and Jurisdiction</h2>
        </div>
        <p i18n>These Terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the High Court of India, Chennai Branch.</p>
        <div class="section-title gradient-text">
            <h2 i18n>12. Changes to Terms and Conditions</h2>
        </div>
        <p i18n>We reserve the right to update or modify these Terms at any time.</p>
        <div class="section-title gradient-text">
           <h2 i18n>13. Contact Information</h2>
        </div>
        <p i18n>Email: <a href="https://mail.google.com/mail/?view=cm&fs=1&to=support@vanuston.com">support&#64;vanuston.com</a></p>
        <p i18n>Website: <a href="https://www.vanuston.com">www.vanuston.com</a></p>
        <div class="section-title gradient-text">
            <h2 i18n>14. Additional Terms for SaaS Products</h2>
         </div>
         <p i18n>For users of our SaaS products (e.g., MedeilCloud POS, MedeilPlus Cloud, Hosbay, Cartfil, Medorbits, AllotMeds):</p>
         <ul>
            <li i18n><strong>Service Availability: </strong>We strive to ensure 99.9% uptime for our cloud-based services. However, we are not liable for downtime caused by factors beyond our control (e.g., internet outages, third-party service disruptions).</li>
            <li i18n><strong>Data Backup: </strong>Data backups are managed by our cloud-hosting partner, Microsoft Azure, and are performed regularly to ensure data integrity and availability.</li>
            <li i18n><strong>User Responsibilities: </strong>Users are responsible for maintaining the confidentiality of their login credentials and ensuring compliance with applicable laws when using our SaaS products.</li>
         </ul>
        </section>
    </div>
<app-footer-style-two></app-footer-style-two>